<template lang="html">
  <div>
    <MainSearch v-bind:queryParams="queryParams" v-bind:currentTab="currentTab" v-bind:fullDate="fullDate"/>
    <MainList   v-bind:queryParams="queryParams" v-bind:currentTab="currentTab" v-bind:fullDate="fullDate" v-bind:fieldobj="fieldobj"/>
  </div>
</template>

<script>

import MainSearch from './MainSearch';
import MainList from './MainList';

import DatePicker from 'vue2-datepicker';
import cSwitch from '../../../../components/Switch';
const moment = require('moment');

export default {
  name: 'MainManagementList',
  components: {
    cSwitch,
    DatePicker,
    MainSearch,
    MainList,
  },
  props: {
    currentTab: {
      type: String
    },
    fieldobj: {
      type: Object
    },
  },
  data () {
    return {
      fullDate: [],
      datepickerLang: {
        yearFormat: "YYYY년",
        monthFormat: "M월",
        days:["일","월","화","수","목","금","토"]
      },

      queryParams: {
        banner_type     : 'keyvisual',
        active_yn       : '',
        day_code        : '',
        start_date      : [],
        end_date        : [],
        search_type     : '',
        search_keyword  : '',
      },
    }
  },
  computed: {
    listRows () {
      return this.items.length
    }
  },
  mounted: function () {

    if (this.queryParams.banner_type == 'banner01' || this.queryParams.banner_type =='banner02'){
      this.fieldobj.fieldItems = this.fieldobj.fieldItems.filter(item => !item.hasOwnProperty('slot_number'));
    }
  },

  methods: {
    getFormatDate(date) {
      if (!date) return;
      return moment(date).format("YYYY-MM-DD");
    },
  }
}


</script>



// WEBPACK FOOTER //
// src/views/site/main/component/MainManagementList.vue